import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

// Business constants
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_site-forge-1160/artifacts/pchuazb3_CoronaGasLtd_Logo.jpg";

export const BUSINESS = {
  name: "Corona Gas",
  tagline: "Heating, Air Conditioning & Gas Fitting Experts",
  phone: "604-576-6457",
  phoneHref: "tel:+16045766457",
  email: "Office@coronagas.ca",
  emailHref: "mailto:Office@coronagas.ca",
  hours: "Mon-Fri 7:00 to 15:30",
  address: "19289 Langley Bypass, Surrey, BC V3S 6K1",
  serviceArea: "Lower Mainland, BC",
  googleReviewsUrl: "https://share.google/TfuKe2HiUmouFO0w0",
};
